import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=d66a4856&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66a4856",
  null
  
)

export default component.exports